import _typeof from './typeof.js';
import _assertThisInitialized from './assertThisInitialized.js';

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}

export { _possibleConstructorReturn as default };
